import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgCentrality = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M23.098 17.891a3.084 3.084 0 0 0-3.59.356l-1.472-.853V13.18c0-.436-.233-.842-.61-1.058l-3.779-2.175V8.083a3.112 3.112 0 1 0-2 0v1.864L7.87 12.122a1.221 1.221 0 0 0-.611 1.058v4.211l-1.473.853a3.084 3.084 0 0 0-3.589-.356 3.116 3.116 0 0 0-1.139 4.248 3.089 3.089 0 0 0 4.228 1.139 3.111 3.111 0 0 0 1.49-3.3l1.352-.787 3.906 2.25a1.23 1.23 0 0 0 1.222 0l3.903-2.247 1.352.786a3.117 3.117 0 0 0 1.49 3.3c1.48.859 3.374.35 4.227-1.139a3.115 3.115 0 0 0-1.13-4.247ZM4.403 21.736a1.322 1.322 0 0 1-1.811-.49 1.333 1.333 0 0 1 .486-1.819 1.322 1.322 0 0 1 1.811.49c.367.635.15 1.452-.486 1.819Zm6.908-16.6a1.334 1.334 0 1 1 2.668 0 1.334 1.334 0 0 1-2.668 0Zm4.723 12.394-3.39 1.953-3.388-1.953v-3.9l3.389-1.953 3.389 1.953v3.9Zm6.664 3.72a1.325 1.325 0 0 1-1.812.488 1.336 1.336 0 0 1-.486-1.82 1.325 1.325 0 0 1 1.811-.488c.637.367.853 1.18.487 1.82Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgCentrality)
const Memo = memo(ForwardRef)
export default Memo
